import { NumericFormat } from "react-number-format";
import { TextField } from "@mui/material";

// Campo de moeda BRL: exibe "R$ 1.234,56" e devolve o número (floatValue) no onChange.
// Elimina ambiguidade de separador decimal/locale (ex.: "800" nunca vira 8).
export default function CampoMoeda({ value, onChange, label, fullWidth, sx, size = "small", ...props }) {
  return (
    <NumericFormat
      customInput={TextField}
      label={label}
      size={size}
      fullWidth={fullWidth}
      sx={sx}
      value={value ?? ""}
      thousandSeparator="."
      decimalSeparator=","
      decimalScale={2}
      allowNegative={false}
      valueIsNumericString={false}
      prefix="R$ "
      onValueChange={(v) => onChange(v.floatValue ?? "")}
      {...props}
    />
  );
}
